import { LoginForm } from "@/components/LoginForm";

const Login = () => {
  return (
    <>
      <div className="flex justify-center items-center h-screen">
        <LoginForm />
      </div>
    </>
  );
};

export default Login;
